//# sourceMappingURL=/s/files/1/0275/6575/2399/t/15/assets/custom.js.map?v=1698673663


function init_custom_size() {
	const sizeSelect = document.querySelector('select[name="custom_size"]');

	if (sizeSelect) {
		sizeSelect.addEventListener("change", function () {
			const selectedValue = this.value;
			const optionName = this.getAttribute('data-placeholder');

			console.log("Selected size:", selectedValue, "Option Name:", optionName);
			
			const targetInput = document.querySelector(
				`input[name="options[${optionName}]"][value="${selectedValue}"]`
			);

			if (targetInput) {
				console.log('targetInput', targetInput);
				targetInput.click();
				targetInput.checked = true;
				targetInput.dispatchEvent(new Event("change", { bubbles: true }));
				console.log("Activated radio input:", targetInput);
			} else {
				console.warn(`Radio input for options[${optionName}] not found. Trying fallback...`);

			}
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
 init_custom_size();
 });

function initHeaderHoverImage() {
    const blocks = document.querySelectorAll('.header-block-links');

    blocks.forEach(block => {
        const links = block.querySelectorAll('.js-header-link');
        const hoverImage = block.querySelector('.js-header-hover-img');

        if (!hoverImage) return;

        let hoverTimeout;

        links.forEach(link => {
            const imageUrl = link.getAttribute('data-collection-image');


                link.addEventListener('mouseenter', () => {
                    clearTimeout(hoverTimeout);
                    hoverImage.style.opacity = '0';
                    setTimeout(() => {
                        if (imageUrl) {
                            hoverImage.src = imageUrl;
                            hoverImage.style.opacity = '1';
                        }else{
                            hoverImage.src = '';
                        }
                    }, 150);
                });

        });

        block.addEventListener('mouseleave', () => {
            hoverTimeout = setTimeout(() => {
                hoverImage.style.opacity = '0';
            }, 100);
        });
    });
}


function headerNavMob() {
    document.body.addEventListener("click", function (e) {
        const trigger = e.target.closest(".js-mob-nav");
        if (!trigger) return;

        const parentItem = trigger.closest(".mobile-menu__item--level-1");
        if (!parentItem) return;

        const navDrawer = document.getElementById("nav-drawer");
        if (!navDrawer) return;

        const isOpen = parentItem.classList.contains("is-open");

        if (isOpen) {
            navDrawer.classList.remove("is-hidden");
            parentItem.classList.add("is-closing");

            parentItem.addEventListener("animationend", function handler() {
                parentItem.classList.remove("is-open");
                parentItem.classList.remove("is-closing");
                parentItem.removeEventListener("animationend", handler);
            });
        } else {
            parentItem.classList.add("is-open");

            navDrawer.classList.add("is-hidden");
        }
    });

}

window.initProductGridItem = function () {
    const productGridItems = document.querySelectorAll('.product-grid-item');
    productGridItems.forEach(item => {

        const colorSwitcher = item.querySelector('.product-grid-color-switcher');

        if (colorSwitcher) {
            const checkedInput = colorSwitcher.querySelector('input[type="radio"]:checked');
            if (checkedInput) {
                updateProductMedia(item, checkedInput);
            }

            colorSwitcher.addEventListener('change', function (event) {
                const target = event.target;
                if (target && target.type === 'radio') {
                    updateProductMedia(item, target);
                }
            });
        }
    });
}

function updateProductMedia(item, input) {

    const linkOne = input.dataset.linkOne;
    const linkTwo = input.dataset.linkTwo;
    const productLink = input.dataset.productLink;
    const productHtmlLink = item.querySelector('.product__media__holder');

    if (productHtmlLink.href.includes(productLink)) return

    if (productHtmlLink && productLink) {
        productHtmlLink.href = productLink;
    }

    const mediaImageContainer = item.querySelector('.product__media__image');
    if (mediaImageContainer) {
        const mediaDivs = mediaImageContainer.querySelectorAll('.product__media');
        if (mediaDivs.length) {
            mediaDivs.forEach(div => {
                div.style.backgroundImage = `url('${linkOne}')`
            });
        }
    }

    const mediaImageContainerHover = item.querySelector('.product__media__hover');
    if (mediaImageContainerHover) {
        const hoverMediaDivs = mediaImageContainerHover.querySelectorAll('.product__media__hover-img');
        hoverMediaDivs.forEach(div => {
            div.style.backgroundImage = `url('${linkTwo}')`;
        });
    }
}

function sizeGuidePopup() {
    const button = document.getElementById("size-guide-btn");
    const popup = document.getElementById("size_guide_popup");
    const overlay = document.querySelector(".drawer__overlay");
    const buttonClose = document.getElementById("closeSizeGuide");
     const sizeGuideBtn2 = document.getElementById('size-guide-btn-2')

     if (sizeGuideBtn2) {
    sizeGuideBtn2.addEventListener('click', function() {
    document.getElementById('size-guide-btn').click();
    });
}

    function openPopup() {
        popup.classList.add("active");

        if (overlay) {
            overlay.classList.add("active");
        }

        const selectElement = document.querySelector(".custom-select-size");

        if (selectElement && !selectElement.classList.contains("tomselected")) {
            new TomSelect(selectElement, {
                placeholder: selectElement.getAttribute("placeholder"),
            });
        }
    }

    function closePopup() {
        popup.classList.remove("active");
        if (overlay) {
            overlay.classList.remove("active");
        }
    }

    if (button && popup) {
        button.addEventListener("click", openPopup);
    }

    if (buttonClose) {
        buttonClose.addEventListener("click", closePopup);
    }

    if (overlay) {
        overlay.addEventListener("click", () => {
            const activePopups = document.querySelectorAll(".size-guide-popup.active");
            activePopups.forEach((activePopup) => {
                activePopup.classList.remove("active");
            });
            overlay.classList.remove("active");
        });
    }
}

function initSizeGuideTabs() {
    const tabButtons = document.querySelectorAll(".tab-btn");
    const tabContents = document.querySelectorAll(".tab-content");
    const unitSelect = document.querySelector(".custom-select-size");

    if (!unitSelect) return console.warn("doesn't exist .custom-select-size");
    if (tabButtons.length === 0 || tabContents.length === 0) {
        return;
    }

    let currentUnit = ["cm", "inch"].includes(unitSelect.value) ? unitSelect.value : "cm";

    function showTab(index) {
        tabButtons.forEach(btn => btn.classList.remove("active"));
        tabContents.forEach(tab => tab.classList.remove("active"));

        const targetBtn = document.querySelector(`.tab-btn[data-tab-index="${index}"]`);
        const targetTab = document.querySelector(`.tab-content[data-tab-index="${index}"]`);

        if (targetBtn && targetTab) {
            targetBtn.classList.add("active");
            targetTab.classList.add("active");
            updateUnitDisplay(targetTab);
        }
    }

    function updateUnitDisplay(tab) {
        const cm = tab.querySelector(".js-size-guide-cm");
        const inch = tab.querySelector(".js-size-guide-inch");

        if (!cm || !inch) {
            return;
        }

        if (currentUnit === "cm") {
            cm.classList.remove("tab-hidden");
            inch.classList.add("tab-hidden");
        } else {
            cm.classList.add("tab-hidden");
            inch.classList.remove("tab-hidden");
        }
    }

    tabButtons.forEach(btn => {
        btn.addEventListener("click", function () {
            const index = this.getAttribute("data-tab-index");
            if (index !== null) {
                showTab(index);
            }
        });
    });

    unitSelect.addEventListener("change", function () {
        currentUnit = this.value;
        const activeTab = document.querySelector(".tab-content.active");
        if (activeTab) updateUnitDisplay(activeTab);
    });

    showTab(0);
}

function updateHeaderState() {
    const header = document.getElementById("SiteHeader");
    const main = document.querySelector("main");

    if (header && main) {
        const headerHeight = header.offsetHeight;

        if (window.scrollY > 0) {
            header.classList.add("fixed", "white-header");
            main.style.marginTop = `${headerHeight}px`;
        } else {
            header.classList.remove("fixed", "white-header");
            main.style.marginTop = "0";
        }
    }
}

function initHeader() {
    const header = document.getElementById("SiteHeader");
    const navItems = document.querySelectorAll("[data-nav-item]");
    let hideTimeout;
    let activeItem = null;
    const menuItemsEl = document.getElementById('menuItems');
    const searchPopdown = header.querySelector(".search-popdown");
    const bodyEl = document.querySelector("body");
    const htmlEl = document.querySelector("html");
    const drawerOverlay = document.querySelector(".main-content");

    header.addEventListener("mouseenter", () => {
        clearTimeout(hideTimeout);
        header.classList.add("is-hovered");
    });

    header.addEventListener("mouseleave", (event) => {
        const related = event.relatedTarget;

        if (related && header.contains(related)) return;

        if (searchPopdown && searchPopdown.querySelector("details[open]")) {
            return;
        }
        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(() => {
            header.classList.remove("is-hovered", "is-opened");

            if (drawerOverlay) {
                setTimeout(() => {
                    drawerOverlay.classList.remove("header-active");
                }, 40);
            }

            if (activeItem) {
                activeItem.classList.remove("is-visible");
                activeItem.setAttribute("aria-expanded", "false");
                activeItem = null;
            }
        }, 300);
    });
    let hideTimeoutTwo;

    menuItemsEl.addEventListener("mouseleave", (event) => {
        const related = event.relatedTarget;
        if ((related && menuItemsEl.contains(related))) return;
        hideTimeoutTwo = setTimeout(() => {
            if (!activeItem) return;
            activeItem.classList.remove("is-visible");
            activeItem.setAttribute("aria-expanded", "false");
            if (drawerOverlay) {
                setTimeout(() => {
                    drawerOverlay.classList.remove("header-active");
                }, 40);
            }

        }, 50)
    })

    navItems.forEach(item => {
        item.addEventListener("mouseenter", () => {
            if (!document.body.classList.contains("js-drawer-open_s") && !document.body.classList.contains("js-drawer-open-cart")) {
                const openDetails = searchPopdown?.querySelector("details[open]");
                if (openDetails) {
                    openDetails.removeAttribute("open");
                    if (bodyEl) {
                        bodyEl.classList.remove("search-opened");
                        bodyEl.style.removeProperty("overflow");
                    }
                    if (htmlEl) {
                        htmlEl.removeAttribute("data-scroll-locked");
                    }
                }

                clearTimeout(hideTimeout);
                clearTimeout(hideTimeoutTwo);
                if (activeItem && activeItem !== item) {
                    activeItem.classList.remove("is-visible");
                    activeItem.setAttribute("aria-expanded", "false");
                }

                activeItem = item;
                item.classList.add("is-visible");
                item.setAttribute("aria-expanded", "true");
                header.classList.add("is-opened", "is-hovered");

                if (drawerOverlay) {
                    drawerOverlay.classList.remove("header-active");

                    if (item.classList.contains("has-submenu")) {
                        drawerOverlay.classList.add("header-active");
                    }
                }
            }
        });

    });
}

function updateStickyBarPosition() {
    const header = document.getElementById("SiteHeader");
    const stickyBar = document.getElementById("CollectionStickyBar");

    if (header && stickyBar) {
        setTimeout(()=>{
            const headerHeight = header.offsetHeight;
            console.log('headerHeight', headerHeight);
            stickyBar.style.top = `${headerHeight}px`;
        }, 700)
    }
}

function initHeaderSubmenuHover() {
    const dropdowns = document.querySelectorAll(".js-dropdown-family");
    let hideTimeout;

    dropdowns.forEach((dropdown) => {
        const navLink = dropdown.querySelector(".js-navlink");
        const submenu = dropdown.querySelector(".header-desc-sub-menu");

        if (!navLink || !submenu) {
            return;
        }

        navLink.addEventListener("mouseenter", () => {
            clearTimeout(hideTimeout);

            document.querySelectorAll(".header-desc-sub-menu.visible").forEach((menu) => {
                if (menu !== submenu) {
                    menu.classList.remove("visible");
                }
            });

            submenu.classList.add("visible");
        });

        dropdown.addEventListener("mouseleave", () => {
            hideTimeout = setTimeout(() => {
                submenu.classList.remove("visible");
            }, 300);
        });

        dropdown.addEventListener("mouseenter", () => {
            clearTimeout(hideTimeout);
        });
    });
}

function setMinHeightHeaderMenu() {
    if (window.innerWidth < 1024) return;

    const wrappers = document.querySelectorAll('.header-links-wrapper');

    wrappers.forEach(wrapper => {
        const subMenus = wrapper.querySelectorAll('.header-desc-sub-menu');

        let maxHeight = 0;

        subMenus.forEach(subMenu => {
            const height = subMenu.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        if (maxHeight > 0) {
            wrapper.style.minHeight = `${maxHeight}px`;
        }
    });
}

function initMobMenuScroll() {
    document.querySelectorAll('.mobile-dropdown[data-collapsible-container]').forEach(container => {
        container.addEventListener('touchstart', function (e) {
            const startY = e.touches[0].clientY;
            const scrollTop = this.scrollTop;
            const totalScroll = this.scrollHeight;
            const currentScroll = scrollTop + this.offsetHeight;

            if (scrollTop === 0) {
                this.scrollTop = 1;
            } else if (currentScroll === totalScroll) {
                this.scrollTop -= 1;
            }
        });

        container.addEventListener('touchmove', function (e) {
            e.stopPropagation();
        }, {passive: false});
    });
}

function initFixedBtnPdpMob() {
    const fixedBlock = document.querySelector('.product__submit__holder');
    const buyContainer = document.querySelector('.buy-size-select-container');

    if (fixedBlock && buyContainer && window.innerWidth < 768) {
        window.addEventListener('scroll', () => {
            const rect = buyContainer.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const scrollY = window.scrollY || window.pageYOffset;
            const docHeight = document.documentElement.scrollHeight;
            const scrolledToBottom = scrollY + windowHeight >= docHeight - 2;

            const isVisible = rect.bottom > 0 && rect.top < windowHeight;

            if (scrolledToBottom) {
                fixedBlock.classList.remove('fixed');
            } else if (isVisible) {
                fixedBlock.classList.remove('fixed');
            } else {
                fixedBlock.classList.add('fixed');
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", updateHeaderState);
document.addEventListener("scroll", updateHeaderState);

window.addEventListener("resize", updateStickyBarPosition);
document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    updateHeaderState();
    initHeaderHoverImage();
    headerNavMob();
    setTimeout(() => {
        window.initProductGridItem();
    }, 1000);
    sizeGuidePopup();
    updateStickyBarPosition();
    setMinHeightHeaderMenu();
    initHeaderSubmenuHover();
    initSizeGuideTabs();
    initMobMenuScroll();
    initFixedBtnPdpMob();

    var selectElement = document.querySelector('.custom-select');
    if (selectElement) {
        var settings = {
            placeholder: selectElement.getAttribute('placeholder')
        };
        new TomSelect(selectElement, settings);
    }
})



